import React, { FunctionComponent, useState } from 'react';
import { IVariant } from '../../../../../../gqlCommon/model/IVariants';
import useWidgetContext from '../../../../../../common/react/useWidgetContext';
import urlUtilities from '../../../../../../../../common/utilities/urlUtilities';
import stringUtilities from '../../../../../../../../common/utilities/stringUtilities';
import SectionLoader from '../../../../../../common/components/loaders/SectionLoader';
import OverlayLoader from '../../../../presentational/loaders/OverlayLoader';
import SpecificationsModal from '../specificationsModal/SpecificationsModal';
import SpecificationsAndFeatures from './SpecificationsAndFeatures';
import useCustomizeCarContext from '../../../../../hooks/useCustomizeCarContext';

export interface ISpecificationsAndFeaturesContainer {
  selectedVariant: IVariant;
}

const SpecificationsAndFeaturesContainer: FunctionComponent<ISpecificationsAndFeaturesContainer> = ({
  selectedVariant,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {
    configuration: { specificationsBrochureUrl },
  } = useWidgetContext();
  const { loading } = useCustomizeCarContext();
  const brochureUrlWithModel = urlUtilities.replaceUrlParamWildcard(
    specificationsBrochureUrl,
    'model',
    stringUtilities.slugify('modelTitle'),
  );
  const attributes = selectedVariant?.variant?.attributes;
  if (!attributes?.keyFeatures.length) {
    return <SectionLoader />;
  }

  return (
    // This loader behaviour is for preventing page size flickering,
    // since options changes also recall car details endpoint.
    <OverlayLoader loading={!attributes?.keyFeatures.length || loading} width={'100%'}>
      <SpecificationsAndFeatures
        keyFeatures={attributes?.keyFeatures}
        engineTitle={attributes?.engine}
        transmissionTitle={attributes?.transmission}
        openModal={() => setIsModalOpen(true)}
        brochureUrl={brochureUrlWithModel}
      />
      <SpecificationsModal
        isSpecFeaturesModalOpen={isModalOpen}
        toggleSpecFeaturesModal={setIsModalOpen}
        selectedVariantId={selectedVariant.variant.code}
      />
    </OverlayLoader>
  );
};

export default SpecificationsAndFeaturesContainer;
